import Vue from "vue";
import Vuex from "vuex";
import router from '@/router'
import store from "@/store/store";
import Service from "@/service/api";
import { getSocket, connectSocket } from "@/service/socketio.service";

const ServerModule = {
    namespaced: true,
    state: {
        isSignIn: false,
        profile: null,
        role: null,
    },

    mutations: {
        isSignIn(state, obj) {
            state.isSignIn = obj;
        },
        setProfile(state, data) {
            state.profile = data;
        },
        setRole(state, role) {
            state.role = role;
        },
    },

    actions: {
        supportReload({ commit }) {
            const user = JSON.parse(localStorage.getItem("user"));
            const accessToken = localStorage.getItem("accessToken");
            store.commit('accessToken', accessToken)
            if (user && accessToken) {
                commit("isSignIn", true);
                commit("setProfile", user);
                commit("setRole", user.role);
                
                connectSocket(accessToken);
                    // เชื่อม Socket notifications และโหลดรายการแจ้งเตือน
                    setTimeout(() => { store.dispatch('notification/bindSocket'); store.dispatch('notification/loadNotifications'); }, 400);
            }
        },
        mockSignIn({ commit }, data) {
            return Service.auth("mockLogin", data, {})
                .then((response) => {
                    const { user, accessToken, refreshToken } = response.data.data;

                    localStorage.setItem("accessToken", accessToken);
                    localStorage.setItem("refreshToken", refreshToken);
                    localStorage.setItem("user", JSON.stringify(user));

                    commit("isSignIn", true);
                    commit("setProfile", user);
                    commit("setRole", user.role);

                    store.dispatch("auth/supportReload", {})
                    store.commit("dialog/loading", false)
                    connectSocket(accessToken);
                    // เชื่อม Socket notifications และโหลดรายการแจ้งเตือน
                    setTimeout(() => { store.dispatch('notification/bindSocket'); store.dispatch('notification/loadNotifications'); }, 400);

                    switch (user.role) {
                        case "admin":
                            store.dispatch('building/refreshBuildings');
                            router.push("/admin");
                            break;
                        case "student_affairs":
                            router.push("/student-affairs/dashboard");
                            break;
                        case "supervisor":
                            router.push("/supervisor/dashboard");
                            break;
                        case "technician":
                            router.push("/technician");
                            break;
                        default:
                            router.push("/user");
                            break;
                    }
                })
                .catch((err) => {
                    console.error("Mock login error:", err);
                    throw err;
                });
        },


        signIn({ commit }, data) {
            return Service.auth("google", data, {})
                .then((response) => {
                    const { user, accessToken, refreshToken } = response.data.data;

                    // เก็บลง localStorage
                    localStorage.setItem("accessToken", accessToken);
                    localStorage.setItem("refreshToken", refreshToken);
                    localStorage.setItem("user", JSON.stringify(user));
                    // commit ลง Vuex
                    commit("isSignIn", true);
                    commit("setProfile", user);
                    commit("setRole", user.role);

                    store.dispatch("auth/supportReload", {})
                    store.commit("dialog/loading", false)
                    connectSocket(accessToken);
                    // เชื่อม Socket notifications และโหลดรายการแจ้งเตือน
                    setTimeout(() => { store.dispatch('notification/bindSocket'); store.dispatch('notification/loadNotifications'); }, 400);
                    // redirect ตาม role
                    switch (user.role) {
                        case "admin":
                            store.dispatch('building/refreshBuildings');
                            router.push("/admin");
                            break;
                        case "student_affairs":
                            router.push("/student-affairs/dashboard");
                            break;
                        case "supervisor":
                            router.push("/supervisor/dashboard");
                            break;
                        case "technician":
                            router.push("/technician");
                            break;
                        default:
                            router.push("/user");
                            break;
                    }
                })
                .catch((err) => {
                    console.error("Google login error:", err);
                    throw err;
                });
        },


        logout({ commit }) {
            const socket = getSocket();
            socket?.disconnect();
            // ลบข้อมูลใน localStorage
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("user");
            // reset Vuex state
            commit("isSignIn", false);
            commit("setProfile", null);
            commit("setRole", null);

            // กลับไปหน้า login
            router.push("/login");
        }

    },

    getters: {
        profile: (state) => state.profile,
        user: (state) => state.profile,
        role: (state) => state.role,
        isSignIn: (state) => state.isSignIn,
    }
};

export default ServerModule;
